import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { BookmarksState } from './state/bookmarks.state';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { BookmarkActionsComponent } from './components/bookmark-actions/bookmark-actions.component';
import { RouterModule } from '@angular/router';
import { PublishModule } from '../publish/publish.module';
import { PublishDialogComponent } from '../publish/components/publish-dialog/publish-dialog.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      BookmarksState
    ]),
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule,
    PublishModule,
    NgxGoogleAnalyticsModule
  ],
  declarations: [BookmarkActionsComponent],
  exports: [BookmarkActionsComponent],
  entryComponents: [
    PublishDialogComponent
  ]
})
export class BookmarksModule { }
